<template>
  <div class="MainPage">
    <div class="questionSubject">
      <span>标题: </span>
      <el-input
          class='osubject'
          type="text"
          placeholder="请输入问卷标题(限固定6个字)"
          maxlength="6"
          show-word-limit
          v-model="qsubject">
      </el-input>
    </div>
    <div class="department">
        <p class="dpname">本部: </p>
        <div class="benDeptWrapper">
          <el-select v-model="selectedDept" multiple placeholder="请选择本部" class='myDpSelect'>
            <el-option
              v-for="(item, index) in dptOptions"
              :key="index"
              :label="item.orgName"
              :value="item.deptSeq"
              class='myOption'>
            </el-option>
          </el-select>
        </div>
    </div>
    <div class="isManageRole">
      <span>部门内人员:</span>
      <el-radio class="firstRole" v-model="managerRole" label='true'>管理岗</el-radio>
      <el-radio v-model="managerRole" label='false'>非管理岗</el-radio>
      <el-radio v-model="managerRole" label=''>所有人员</el-radio>
      <span class="warnYong">* 注： 所有人员选项只在本部选中的情况下生效</span>
    </div>
    <div class="selectedMen">
      <p>指定工号: </p>
      <div class="seMenWrapper">
          <el-input
            class="manCon"
            type="textarea"
            :rows="6"
            placeholder="请输入指定的员工工号(以英文逗号进行分隔)"
            v-model="selectedMen">
          </el-input>
        </div>
    </div>
    <div class="endTime">
      <span>截止日期:</span>
      <el-date-picker
        v-model="invalidTime"
        type="date"
        :editable='editable'
        :readonly='timerreadonly'
        value-format='yyyy-MM-dd'
        placeholder="请选择截止日期"
        :picker-options="pickerDayOptions">
      </el-date-picker>
      <span class="warnFont">* 注： 当天及当天之前的日期不可选</span>
    </div>
    <main-table></main-table>
    <div class="opinion">
      <p>
        <span>是否添加意见输入框: </span>
        <el-radio class="firstRadio" v-model="opinionInput" label='true'>是</el-radio>
        <el-radio v-model="opinionInput" label='false'>否</el-radio>
      </p>
      <div class="opinionSub" v-if="opinionInput === 'true'">
          <el-input
            type="text"
            placeholder="请输入意见输入框的标题"
            v-model="opinionSubject">
          </el-input>
      </div>
    </div>
    <div class="opinion">
      <p>
        <span>是否允许多次接收: </span>
        <el-radio class="firstRadio" v-model="multiSelect" label='true'>是</el-radio>
        <el-radio v-model="multiSelect" label='false'>否</el-radio>
      </p>
    </div>
    <div class="tipWrapper">
      <p class="tipP">说明: </p>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入说明内容(限制在100字符以内)"
          maxlength="100"
          show-word-limit
          v-model="explain">
        </el-input>
    </div>
    <div class="submit">
        <el-button class="submitBtn" type="primary" :loading="submitLoading" @click='submit()'>{{submitLoading ? '提交中' : '提&nbsp;&nbsp;交'}}</el-button>
        <!-- <el-button class="submitBtn" type="primary" @click='resetAllInfoes()'>重置</el-button> -->
    </div>
  </div>
</template>

<script>
import MainTable from '@/components/MainTable'
import {mapGetters, mapMutations} from 'vuex'
import address from '@/libs/address'
import {dealPersonData, strToArrAndValidator} from '@/libs/tools'
export default {
  name: 'MainPage',
  components: {
    MainTable
  },
  computed: {
    ...mapGetters(['getAllTableInfo'])
  },
  data () {
    return {
      opinionSubject: '',
      opinionInput: 'false',
      multiSelect: 'false', // 是否多次接收
      qsubject: '',
      selectedMen: '',
      timerreadonly: false,
      editable: false,
      invalidTime: '',
      pickerDayOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      managerRole: '',
      explain: '',
      submitLoading: false,
      selectedDept: [],
      dptOptions: [],
      userId: '',
      casCookie: '',
      sessionId: ''
    }
  },
  created () {
    this.userId = this.$route.query.userId;
    this.casCookie = this.$route.query.casCookie;
    this.sessionId = this.$route.query.sessionId;
  },
  methods: {
    ...mapMutations(['resetAllTableInfoes']),
    submit() {
      // 提交前进行判断空值的判断, 对题目的判空
      let submitObj = {};
      // 调查的标题
      submitObj.qsubject = this.qsubject.replace(/\s/g, '');
      // 选择的本部
      submitObj.selectedDept = this.selectedDept.join(',');
      // 是否管理岗
      submitObj.managerRole = this.managerRole;
      // 截止日期
      submitObj.invalidTime = this.invalidTime;
      // 选中的个人
      submitObj.selectedPersons = strToArrAndValidator(this.selectedMen);
      // 选中的题目
      submitObj.allSubjectTableItem = dealPersonData(this.getAllTableInfo, ['rightResult']);
      // 是否显示意见输入
      submitObj.opinions = {
        show: this.opinionInput,
        value: this.opinionSubject
      }
      // 是否允许多次接收
      submitObj.multiReceive = this.multiSelect === 'true' ? true : false;
      // 说明
      submitObj.explains = this.explain;

      if (!(submitObj.qsubject.length == 6)) {
        this.$message.error('调查问卷的标题内容固定长度为6！！');
        return;
      }
      if (!submitObj.selectedDept&&!submitObj.managerRole&&!submitObj.selectedPersons) {
        this.$message.error('请选择推送的条件如：本部,部门人员,指定工号！！');
        return;
      }
      // 默认30天
      if (!this.invalidTime) {
        this.$message.error('截止时间不能为空！！');
        return;
      }
      if (submitObj.allSubjectTableItem && (submitObj.allSubjectTableItem.length < 2)) {
        this.$message.error('录入测试题目不得小于2题！！');
        return;
      }
      if (submitObj.opinions.show === 'true' && !submitObj.opinions.value) {
        this.$message.error('选中显示意见框时, 意见框的标题不能为空！！');
        return;
      }

      // console.log('******', JSON.stringify(submitObj));
      // 要标记是否casCookie和sessionId是否失效，以方便来提示用户时什么操作，若果是这种情况，提示刷新啊。
      // 发送数据
      this.submitLoading = true; // 按钮增加加载动画
      this.$post(address.applyResources+
      '?userId='+this.userId +
      "&casCookie="+this.casCookie +
      "&sessionId="+this.sessionId, submitObj)
      .then((res) => {
        // console.log(res);
        this.submitLoading = false;
        if (!res.errorCode && res.errorCode == 0) {
          //  成功
          this.$message.success('数据提交成功！');
          this.resetAllInfoes();
          // this.$router.push('/editTables')
        } else if (res.errorCode == 9999) {
          //  会话过期, 请重新登录
          this.$message.error('会话已过期，请重新登录!')
          this.$router.push({path: '/login'});
        } else {
          //  插入数据失败
          this.$message.error('数据提交失败，请重试！')
        }
      })
      .catch((err) => {
        this.submitLoading = false;
        this.$message.error('网络出错，请检查网络链接，重新提交！')
      });
    },
    resetAllInfoes() {
      // 各个选项的清空
      this.qsubject = ''; // 标题
      this.selectedDept = []; // 本部
      // this.dptOptions = []; // 本部字段
      this.managerRole = ''; // 是否管理岗
      this.selectedMen = ''; // 指定工号
      this.invalidTime = ''; // 截止时间
      this.resetAllTableInfoes(); // 表格置空
      this.opinionSubject = ''; // 意见框
      this.opinionInput = 'false'; // 意见框
      this.multiSelect = 'false'; // 多次接收
      this.explain = ''; // 说明
    }
  },
  beforeMount () {
    const loading = this.$loading({
          lock: true,
          text: '数据加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.2)',
          color: 'red',
          customClass: 'mainLoading'
    });
    this.$get(address.searchDpt,{
      userId: this.userId,
      sessionId: this.sessionId,
      casCookie: this.casCookie
    }).then((res) => {
      // console.log(res);
      loading.close();
      if (!res.errorCode && res.errorCode == 0) {
        this.$message.success('数据加载成功！');
        this.dptOptions = res.data;
      } else if (res.errorCode == 9999) {
        //  会话过期, 请重新登录
        this.$message.error('会话已过期，请重新登录!');
        this.$router.push({path: '/login'});
      } else {
        this.$message.error('数据加载失败, 请刷新页面重试！');
      }
    }).catch((err) => {
      loading.close();
      this.$message.error('网络错误, 请检查网络是否正常并刷新重试！');
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
@import "~@/common/mixin.scss";

.MainPage {
  text-align: left;
  font-size: 14px;
  margin-top: 10px;
  .questionSubject {
    .osubject {
      display: inline-block;
      width: 360px;
    }
  }
  .department {
    margin-top: 20px;
    .dpname {
      margin-top: 10px;
    }
    .benDeptWrapper {
      margin-top: 16px;
      .el-select.el-select--small {
        width: 100%;
      }
    }
  }
  .opinion {
    margin-top: 20px;
    & > p {
      .firstRadio {
        margin-left: 20px;
      }
    }
    .opinionSub {
      margin-top: 10px;
    }
  }
  .selectedMen {
    margin-top: 20px;
    .seMenWrapper {
      margin-top: 10px;
    }
  }
  .endTime {
    margin-top: 20px;
    .warnFont {
      color: red;
      font-size: 10px;
    }
  }
  .isManageRole {
    margin-top: 20px;
    .firstRole {
      margin-left: 20px;
    }
    .warnYong {
      color: red;
      font-size: 10px;
    }
  }
  .tipWrapper {
    margin-top: 20px;
    .tipP {
      padding-bottom: 10px;
    }
  }
  .submit {
    padding: 20px 0px 10px 0px;
    text-align: center;
    .submitBtn {
      background: #003c8d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue